export default __webpack_public_path__ + "static/media/explore1.ade5f079.png";